import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-eliminarcuenta',
  templateUrl: './eliminarcuenta.component.html',
  styleUrls: ['./eliminarcuenta.component.css'],
})
export class EliminarcuentaComponent {
  deletionForm: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private functions: AngularFireFunctions
  ) {
    this.deletionForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    if (this.deletionForm.valid) {
      this.submitted = true;
      const email = this.deletionForm.value.email;

      const bodydata = {
        email: email,
      }
      // Aquí puedes integrar tu lógica de envío al backend o servicio de soporte
      const callable = this.functions.httpsCallable('addRoom');
      const obs = callable({ saladata: bodydata });
      console.log(`Solicitud de eliminación enviada para: ${email}`);
    }
  }
}
